import { ProductionModuleLayout } from "@features/production/components/ProductionModuleLayout";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/production")({
  loader: requirePermission(PERMISSIONS.PRODUCTION.DASHBOARD.VIEW, {
    redirectTo: "/unauthorized",
  }),
  staticData: {
    title: "Production",
    permission: PERMISSIONS.PRODUCTION.DASHBOARD.VIEW,
    module: "production",
    section: "Production",
    order: 40,
    // The index route carries the nav entry — a second showInNav here would
    // normalize to the same "/production" path as index.tsx (duplicate React key).
    showInNav: false,
  },
  component: ProductionModuleLayout,
});
